import React, { Component } from "react";
import { Segment, Divider, Icon, Grid, Form, Field } from "semantic-ui-react";
import PaymentButton from "./PaymentButton";
import PRBContainer from "./PRBContainer";
import { formValueSelector } from "redux-form";
import { connect } from "react-redux";
import calculator from "../../../utilities/priceCalculator";
import convertTime from "../../../utilities/convertTimeToReadable";
import moment from "moment";
import PaymentSection from "./PaymentSection";

class PriceSummarySticky extends Component {
  render() {
    const {
      numBedrooms: bedrooms,
      numBathrooms: bathrooms,
      frequency,
      discountCode,
      selectedDate,
      selectedTime: time
    } = this.props;
    const price = calculator(frequency, bedrooms, bathrooms);
    const discount = 0;
    const date = moment.utc(selectedDate).format("MMMM Do YYYY");
    const service = (function() {
      switch (frequency) {
        case "oneTime":
          return "One Time Service";
          break;
        case "everyWeek":
          return "Every week";
          break;
        case "twoWeeks":
          return "Every 2 weeks";
          break;
        case "fourWeeks":
          return "Every 4 weeks";
          break;

        default:
          break;
      }
    })();
    return (
      // <Sticky context={this.props.contextRef} offset={100}>
      <Segment style={{ width: "100%" }}>
        <h3>Booking Summary</h3>
        <div style={{ textAlign: "left" }}>
          <Divider />
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <h4>Booking details</h4>
          </div>
          <Grid verticalAlign="middle">
            <Grid.Row>
              <Grid.Column width={2}>
                <Icon name="home" size="large" />
              </Grid.Column>
              <Grid.Column width={14}>
                {bedrooms} {bedrooms > 1 ? "Bedrooms" : "Bedroom"}, {bathrooms}{" "}
                {bathrooms > 1 ? "Bathrooms" : "Bathroom"}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <Icon name="calendar" size="large" />
              </Grid.Column>
              <Grid.Column width={14}>
                {date} at {convertTime(time)}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={2}>
                <Icon name="refresh" size="large" />
              </Grid.Column>
              <Grid.Column width={14}>{service}</Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider />
          {discount > 0 && (
            <div>
              Subtotal: ${price + discount}
              <br />
              Discount: ${discount}
              <br />
            </div>
          )}
          Total: ${price}
        </div>
        <Divider />
        <h3>Payment Info</h3>
        <PaymentSection
          price={parseFloat(price) * 100}
          user={this.props.user}
          firstName={this.props.firstName}
          lastName={this.props.lastName}
          email={this.props.email}
          phone={this.props.phone}
          password={this.props.password}
          address={
            this.props.aptNumber ? (
              this.props.address + " " + this.props.aptNumber
            ) : (
              this.props.address
            )
          }
          city={this.props.city}
          zip={this.props.zip}
          numBedrooms={this.props.numBedrooms}
          numBathrooms={this.props.numBathrooms}
          discountCode={this.props.discountCode}
          selectedDate={this.props.selectedDate}
          selectedTime={this.props.selectedTime}
          frequency={this.props.frequency}
        />
        {/* <Divider />
        <PaymentButton
          price={parseFloat(price) * 100}
          user={this.props.user}
          firstName={this.props.firstName}
          lastName={this.props.lastName}
          email={this.props.email}
          phone={this.props.phone}
          password={this.props.password}
          address={
            this.props.aptNumber ? (
              this.props.address + " " + this.props.aptNumber
            ) : (
              this.props.address
            )
          }
          city={this.props.city}
          zip={this.props.zip}
          numBedrooms={this.props.numBedrooms}
          numBathrooms={this.props.numBathrooms}
          discountCode={this.props.discountCode}
          selectedDate={this.props.selectedDate}
          selectedTime={this.props.selectedTime}
          frequency={this.props.frequency}
        /> */}
      </Segment>
      // </Sticky>
    );
  }
}
const Selector = formValueSelector("contact");
PriceSummarySticky = connect(state =>
  Selector(
    state,
    "firstName",
    "lastName",
    "email",
    "phone",
    "password",
    "address",
    "aptNumber",
    "city",
    "zip",
    "numBedrooms",
    "numBathrooms",
    "discountCode",
    "selectedDate",
    "selectedTime",
    "frequency"
  )
)(PriceSummarySticky);
export default PriceSummarySticky;



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/PriceSummarySticky.jsx